import React from "react";
import styled from "styled-components";
import {ExternalLink} from "components";
import adidas from "apps/DRAW_PREDICTOR/assets/images/logos/adidas.png";
import cocaCola from "apps/DRAW_PREDICTOR/assets/images/logos/coca-cola.png";
import hyundai from "apps/DRAW_PREDICTOR/assets/images/logos/hyundai.png";
import qatar from "apps/DRAW_PREDICTOR/assets/images/logos/qatar.png";
import visa from "apps/DRAW_PREDICTOR/assets/images/logos/visa.png";
import wanda from "apps/DRAW_PREDICTOR/assets/images/logos/wanda.png";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import {media} from "assets/css/media";

const FooterWrap = styled.footer`
	z-index: 1;
	background: #ffffff;
	border-top: 1px solid #e4e8f0;

	h6 {
		color: #000f2c;
		font-size: 20px;
		line-height: 24px;
		margin-bottom: 16px;
		text-align: center;
	}
	> div {
		margin: calc(57px - 1em) auto;

		@media (min-width: 576px) {
			max-width: 540px;
		}
		@media (min-width: 768px) {
			max-width: 720px;
		}
		@media (min-width: 992px) {
			max-width: 960px;
		}
		@media (min-width: 1200px) {
			max-width: 1140px;
		}
		@media (min-width: 1400px) {
			max-width: 1320px;
		}
	}
`;

const Images = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	margin: 20px auto;
	a {
		padding: 0 32px;
		margin-top: 32px;
		flex: 0 0 auto;
		width: 100%;
		text-align: center;
		img {
			max-width: 100%;
		}

		@media (min-width: 576px) {
			flex: 0 0 auto;
			width: 50%;
		}
		@media (min-width: 992px) {
			flex: 0 0 auto;
			width: 33.3333333333%;
		}
		@media (min-width: 1200px) {
			flex: 0 0 auto;
			width: auto;
		}
	}
`;

const List = styled.ul`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	a {
		color: #505b73;
		margin-bottom: 16px;
		margin-inline-end: 32px;
		transition: 0.1s linear;
		&:hover {
			color: #1277d9;
		}
	}
	@media (max-width: ${media.tablet}) {
		flex-direction: column;
		li {
			margin-bottom: 10px;
		}
	}
`;

const Bottom = styled.div`
	border-top: 1px solid #e4e8f0;
	padding-top: 20px;
`;

const Copyright = styled.div`
	color: #000f2c;
	font-size: 16px;
	@media (max-width: ${media.tablet}) {
		text-align: center;
	}
`;

export const Footer: React.FC = () => {
	const {t} = useTranslation(LANGUAGE_PATH);

	return (
		<FooterWrap>
			<div>
				<div>
					<h6>{t("page.footer.partner")}</h6>
					<Images className="row justify-content-center ff-logostrip_logos__hLXEI">
						<ExternalLink href="https://www.adidas.co.uk/football">
							<img
								decoding="async"
								loading="lazy"
								height="57"
								width="114"
								src={adidas}
								alt="Adidas Logo"
								title="Adidas Logo"
							/>
						</ExternalLink>
						<ExternalLink href="https://www.coca-cola.com/">
							<img
								decoding="async"
								loading="lazy"
								height="57"
								width="114"
								src={cocaCola}
								alt="Coca Cola"
								title="Coca Cola"
							/>
						</ExternalLink>
						<ExternalLink href="https://www.wanda-group.com/">
							<img
								decoding="async"
								loading="lazy"
								height="57"
								width="114"
								src={wanda}
								alt="Wanda group"
								title="Wanda group"
							/>
						</ExternalLink>
						<ExternalLink href="https://www.fifa.com/about-fifa/commercial/partners/hundai-kia-motors">
							<img
								decoding="async"
								loading="lazy"
								height="57"
								width="114"
								src={hyundai}
								alt="Hyundai"
								title="Hyundai"
							/>
						</ExternalLink>
						<ExternalLink href="https://www.qatarairways.com/en-dk/homepage.html">
							<img
								decoding="async"
								loading="lazy"
								height="57"
								width="114"
								src={qatar}
								alt="Qatar Airways"
								title="Qatar Airways"
							/>
						</ExternalLink>
						<ExternalLink href="https://www.visa.com/">
							<img
								decoding="async"
								loading="lazy"
								height="50"
								width="100"
								src={visa}
								alt="VISA"
								title="VISA"
							/>
						</ExternalLink>
					</Images>
				</div>
			</div>
			<Bottom>
				<div className="row ff-py-16 ff-py-lg-8 ff-footer_bottomRow__2JDpj">
					<div className="col-8 col-lg-10 d-flex align-self-center">
						<div className="ff-link-list_linkListContainer__3k84T ff-link-list_horizontalList__1ErNX">
							<List className="ff-link-list_linkList__34I__">
								<li className="ff-link-list_horizontalListLinks__1JFx_ ff-mb-8 ff-mb-lg-0">
									<a
										href="https://www.fifa.com/terms-of-service"
										className="ff-mr-xl-32 ff-mr-16 overline ff-link-list_link__3RW_4">
										{t("page.footer.terms")}
									</a>
								</li>
								<li className="ff-link-list_horizontalListLinks__1JFx_ ff-mb-8 ff-mb-lg-0">
									<a
										href="https://www.fifa.com/data-protection-portal"
										className="ff-mr-xl-32 ff-mr-16 overline ff-link-list_link__3RW_4">
										{t("page.footer.data")}
									</a>
								</li>
								<li className="ff-link-list_horizontalListLinks__1JFx_ ff-mb-8 ff-mb-lg-0">
									<a
										href="https://www.fifa.com/downloads"
										className="ff-mr-xl-32 ff-mr-16 overline ff-link-list_link__3RW_4">
										{t("page.footer.downloads")}
									</a>
								</li>
								<li className="ff-link-list_horizontalListLinks__1JFx_ ff-mb-8 ff-mb-lg-0">
									<a
										href="https://www.fifa.com/mobile"
										className="ff-mr-xl-32 ff-mr-16 overline ff-link-list_link__3RW_4">
										{t("page.footer.app")}
									</a>
								</li>
							</List>
						</div>
					</div>
					<Copyright className="col-12 d-flex align-self-center">
						<p className="ff-mt-16 ff-mb-0 ff-mt-lg-0">
							<b className="overline">{t("page.footer.copyright")}</b>
						</p>
					</Copyright>
				</div>
			</Bottom>
		</FooterWrap>
	);
};
